"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "62",
    height: "62",
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: styles
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "62",
    height: "62"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#2F61E0"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    opacity: "0.2",
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#EF7F57"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "10",
    y: "22",
    width: "42",
    height: "50",
    rx: "6",
    fill: "#EF7F57"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "24",
    y: "38",
    width: "14",
    height: "3",
    rx: "1.5",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "19",
    y: "45",
    width: "24",
    height: "3",
    rx: "1.5",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "10",
    width: "30",
    height: "21",
    rx: "10.5",
    fill: "#BE3D0E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0003 9.66666C30.5401 9.66666 30.167 10.0398 30.167 10.5V13V17.1667C30.167 17.6269 30.5401 18 31.0003 18C31.4606 18 31.8337 17.6269 31.8337 17.1667V13V10.5C31.8337 10.0398 31.4606 9.66666 31.0003 9.66666Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7715 23.8333C28.1415 25.271 29.4466 26.3333 30.9998 26.3333C32.553 26.3333 33.8581 25.271 34.2281 23.8333H27.7715Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.5 22.1667C23.5 18.0245 26.8579 14.6667 31 14.6667C35.1421 14.6667 38.5 18.0245 38.5 22.1667H23.5Z",
    fill: "white"
  })));
}

var _default = Svg;
exports.default = _default;